import { env } from './env'

export interface TenantBranding {
  appName: string
  appLogo: string
  headerBackground: string
  /** true = dark gradient header (white text/icons); false = light header (dark text/icons) */
  darkHeader: boolean
  poweredByLogo: string
  primaryColor: string
  secondaryColor: string
  accentColor: string
  footerAccentColor: string
}

export const BRANDING: TenantBranding = {
  appName:          env('VITE_APP_NAME')           || 'Region 4',
  appLogo:          env('VITE_LOGO_URL')           || '/r4-logo-1.png',
  headerBackground: env('VITE_HEADER_BG')          || 'linear-gradient(90deg, #0c2f45 0%, #4c7991 50%, #348291 100%)',
  darkHeader:       env('VITE_DARK_HEADER')        !== 'false',
  poweredByLogo:    env('VITE_POWERED_BY_LOGO_URL')|| '/Region4 DevelopWorks Logo Stacked - 72PPI_White.png',
  primaryColor:     env('VITE_PRIMARY_COLOR')      || '#009999',
  secondaryColor:   env('VITE_SECONDARY_COLOR')    || '#086296',
  accentColor:      env('VITE_ACCENT_COLOR')       || '',
  footerAccentColor: env('VITE_FOOTER_ACCENT_COLOR') || '',
}
